module.exports = __webpack_public_path__ + "static/shifts-hero-2-e6b33631415044f6f8e24353ee2337df.png";